import { http } from '@/api/Connect';
import { BASE_WEB_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  ITotalTipsStatsPayload,
  ITotalTipsStatsResponse,
  ITipsStatsHistoryPayload,
  ITipsStatsHistoryResponse
} from '@/api/schema';

const API_TIPS_STATS = (): string => `${BASE_WEB_OPERATOR()}/tips`;

export async function getCopyStakeTipsStats(
  params: ITipsStatsHistoryPayload
): Promise<ITipsStatsHistoryResponse> {
  return http
    .get(API_TIPS_STATS(), {
      params,
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<ITipsStatsHistoryResponse>) => data);
}

export async function getCopyStakeTotalTipsStats(
  params: ITotalTipsStatsPayload
): Promise<ITotalTipsStatsResponse> {
  return http
    .get(`${API_TIPS_STATS()}/total`, {
      params
    })
    .then(({ data }: AxiosResponse<ITotalTipsStatsResponse>) => data);
}

export async function getCopyStakeTipsStatsCsv(
  params: ITipsStatsHistoryPayload
): Promise<string> {
  return http
    .get(`${API_TIPS_STATS()}/csv`, {
      params
    })
    .then(({ data }: AxiosResponse<string>) => data);
}
